var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDummySquareSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.2002V12.8002C8 13.9203 8 14.4801 8.21799 14.9079C8.40973 15.2842 8.71547 15.5905 9.0918 15.7822C9.5192 16 10.079 16 11.1969 16H12.8031C13.921 16 14.48 16 14.9074 15.7822C15.2837 15.5905 15.5905 15.2842 15.7822 14.9079C16 14.4805 16 13.9215 16 12.8036V11.1969C16 10.079 16 9.5192 15.7822 9.0918C15.5905 8.71547 15.2837 8.40973 14.9074 8.21799C14.4796 8 13.9203 8 12.8002 8H11.2002C10.0801 8 9.51962 8 9.0918 8.21799C8.71547 8.40973 8.40973 8.71547 8.21799 9.0918C8 9.51962 8 10.0801 8 11.2002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummySquareSmall);
export default __webpack_public_path__ + "static/media/Dummy_Square_Small.69c904172f2872d8a6f4f488303d5f67.svg";
export { ForwardRef as ReactComponent };